import React, { Component } from 'react'
import moment from 'moment'
import SelectField from './SelectField'
import { DateRangePicker } from 'react-dates'
import { push } from 'datalayer';
import Recaptcha from './Recaptcha'
import {gettext} from 'django';
require('../sass/app.scss')

const accomodationTypes = [
  { value: 'Parcele', label: gettext('Camping') },
  { value: 'Mobilne kućice', label: gettext('Mobile Homes') }
]
const persons = [
  { value: 0, label: '0' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' }
]
const year = moment().year()

export class ReservationForm extends Component {
  state = {
    startDate: null,
    endDate: null,
    focusedInput: null,
    schema: {
      accommodation_type: '',
      check_in_day: '',
      check_in_month: '',
      check_in_year: '',
      nights: '',
      adults_count: 0,
      children_older_count: 0,
      children_younger_count: 0,
      pets_count: 0
    },
    disabled: true
  }

  componentWillMount() {
    this.updateWidth()
    window.addEventListener('resize', this.updateWidth.bind(this))
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidth.bind(this))
  }

  updateWidth = () => {
    this.setState({ windowWidth: window.innerWidth, focusedInput: null })
  }

  verifyCallback = () => {
    this.setState({ disabled: false })
  }

  expiredCallback = () => {
    this.setState({ disabled: true })
  }

  handleChanges = event => {
    const name = event.target.name
    const value = event.target.value
    let schema = this.state.schema
    schema[name] = value
    this.setState({ schema })
  }

  handleDateChange = ({ startDate, endDate }) => {
    let schema = this.state.schema

    if (startDate) {
      schema.check_in_day = startDate.date()
      schema.check_in_month = startDate.month() + 1
      schema.check_in_year = startDate.year()
    }
    if (startDate && endDate) {
      schema.nights = endDate.diff(startDate, 'days')
    }

    this.setState({ startDate, endDate, schema })
  }

  handleSubmit = event => {
    if (this.state.schema.accommodation_type === '' || !this.state.startDate || !this.state.endDate) {
      event.preventDefault();
      return false;
    }
    push({
      'event': 'trackEvent',
      'eventCategory': 'Form Submit',
      'eventAction': 'Reservation Form',
      'eventLabel': 'Success'
    });
  }

  render = () => (
    <div className='container with-gap'>
      <form action='#' method='post' id='phobs_book' name='phobs_book' onSubmit={this.handleSubmit}>
        <div className='columns'>
          <div className='column booking-wrapper'>
            <div className="columns">
              <div className="column is-6-desktop is-offset-3-desktop">
                <div className='columns'>
                  <div className='column'>
                    <h3>{gettext('Online reservation')}</h3>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <div className='first-name'>
                      <label>{gettext('First name')}</label>
                      <input name='first_name'></input>
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <div className='last-name'>
                      <label>{gettext('Last name')}</label>
                      <input name='last_name'></input>
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <div className='email'>
                      <label>{gettext('Email address')}</label>
                      <input name='email' type='email'></input>
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <div className='accomodation-type'>
                      <label>{gettext('Accommodation type')}</label>
                      <SelectField
                        name='accommodation_type'
                        placeholder={gettext('Select accommodation type')}
                        displayProp='label'
                        valueProp='value'
                        options={accomodationTypes}
                        changeCallback={this.handleChanges}
                        value={this.state.schema.accommodation_type}
                      />
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <div className='dates'>
                      <div className='columns'>
                        <div className='column picker-button'>
                          <div>
                            <div className='dates-labels'>
                              <label>{gettext('Arrival')}</label>
                              <label>{gettext('Departure')}</label>
                            </div>
                            <DateRangePicker
                              openDirection='down'
                              startDatePlaceholderText={gettext('Arrival')}
                              endDatePlaceholderText={gettext('Departure')}
                              startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                              startDateId='start_date' // PropTypes.string.isRequired,
                              endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                              endDateId='end_date' // PropTypes.string.isRequired,
                              onDatesChange={this.handleDateChange} // PropTypes.func.isRequired,
                              focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                              onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired
                              firstDayOfWeek={1}
                              numberOfMonths={this.state.windowWidth >= 769 ? 2 : 1}
                              displayFormat='DD/MM/YYYY'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column is-6'>
                    <div className='persons'>
                      <label>{gettext('Adults (over 12 years)')}</label>
                      <SelectField name='adults_count' placeholder='' displayProp='label' valueProp='value' options={persons} changeCallback={this.handleChanges} value={this.state.schema.adults_count} />
                    </div>
                  </div>
                  <div className='column is-6 second-child'>
                    <div className='persons'>
                      <label>{gettext('Children (from 7 to 11,99 years)')}</label>
                      <SelectField name='children_older_count' placeholder='' displayProp='label' valueProp='value' options={persons} changeCallback={this.handleChanges} value={this.state.schema.children_older_count} />
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column is-6'>
                    <div className='persons'>
                      <label>{gettext('Children (up to 6,99 years)')}</label>
                      <SelectField name='children_younger_count' placeholder='' displayProp='label' valueProp='value' options={persons} changeCallback={this.handleChanges} value={this.state.schema.children_younger_count} />
                    </div>
                  </div>
                  <div className='column is-6 second-child'>
                    <div className='persons pets'>
                      <label>{gettext('Pets')}</label>
                      <SelectField name='pets_count' placeholder='' displayProp='label' valueProp='value' options={persons} changeCallback={this.handleChanges} value={this.state.schema.pets_count} />
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <div className='note'>
                      <label>{gettext('Note')}</label>
                      <textarea name='note'></textarea>
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <Recaptcha
                      sitekey="6LcpsFsUAAAAANV4n93h2belEPhV35ZxqN1ubH9S"
                      render="explicit"
                      verifyCallback={this.verifyCallback}
                      expiredCallback={this.expiredCallback}
                    />
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <button type='submit' className='btn-blue' disabled={this.state.disabled}>{gettext('Make a reservation')}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <input name='check_in_day' type='hidden' style={{ display: 'none' }} value={this.state.schema.check_in_day} />
        <input name='check_in_month' type='hidden' style={{ display: 'none' }} value={this.state.schema.check_in_month} />
        <input name='check_in_year' type='hidden' style={{ display: 'none' }} value={this.state.schema.check_in_year} />
        <input name='nights' type='hidden' style={{ display: 'none' }} value={this.state.schema.nights} />
        <input name='csrfmiddlewaretoken' type='hidden' style={{ display: 'none' }} value={window.RESERVATION_CSRF_TOKEN} />
      </form>
    </div>
  )
}

export default ReservationForm



// WEBPACK FOOTER //
// ./src/js/ReservationForm.js